module.exports = __webpack_public_path__ + "static/media/KAPorg-blue.113cd696.svg";